export const IS_MODAL = "ST_PROJECTS_IS_MODAL"
export const ST_PROJECTS_IS_CONFIRMATION_MODAL = "ST_PROJECTS_IS_CONFIRMATION_MODAL"
export const ST_PROJECTS_SET_TAB = "ST_PROJECTS_SET_TAB"
export const ST_PROJECTS_SET_PAGE = "ST_PROJECTS_SET_PAGE"
export const SET_ST_PROJECT_ID = "SET_ST_PROJECT_ID"